/*
 * Lia – Mengenrabatt-Kästchen (snippets/product-mengenrabatt.liquid)
 * Portiert von Frey Nutrition, angepasst an das Wonder-Theme:
 *  - Variantenpicker: <variant-options data-section>, Option 1 = erstes .wt-product__option
 *  - Variantenwechsel: Event "variantChangeEnd" (bubbled), Variante = el.currentVariant
 *  - Warenkorb: /cart/add.js + cart-drawer.renderContents(res, isClosedCart) + PUB_SUB cartUpdate
 * Der Rabatt selbst kommt aus einem automatischen Mengenrabatt im Shopify-Admin.
 */
(function () {
  if (window.customElements.get('product-mengenrabatt')) return;

  // Eine Instanz pro Section – dokumentweite Listener nur einmal binden
  // (überlebt Re-Renders im Theme-Editor ohne doppelte Handler).
  const instances = new Map();

  const esc = (v) => String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const norm = (v) => String(v == null ? '' : v).trim().toLowerCase();
  const list = (raw) => String(raw || '').split(',').map(norm).filter(Boolean);

  document.addEventListener('variantChangeEnd', (e) => {
    const picker = e.target;
    if (!picker || picker.tagName !== 'VARIANT-OPTIONS') return;
    const inst = instances.get(picker.dataset.section);
    if (inst && inst.isConnected) inst._onVariantChange(picker.currentVariant);
  });

  // Farb-Dropdowns: Klick außerhalb schließt (einmal global)
  function closeDropdown(dd) {
    const list = dd.querySelector('.lia-mr__dd-list');
    const btn = dd.querySelector('.lia-mr__dd-btn');
    if (list) list.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    dd.classList.remove('is-open');
  }
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.lia-mr__dd.is-open').forEach((dd) => { if (!dd.contains(e.target)) closeDropdown(dd); });
  });

  // Capture-Phase: greift vor dem Submit-Handler von <product-form>
  document.addEventListener('submit', (evt) => {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement)) return;
    // form.id wird vom <input name="id"> überschattet -> getAttribute
    const formId = form.getAttribute('id') || '';
    for (const inst of instances.values()) {
      if (!inst.isConnected || formId !== inst.formId || inst.isExcluded) continue;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      inst._handleAddToCart(form);
      return;
    }
  }, true);

  class ProductMengenrabatt extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.sectionHandle = this.dataset.sectionHandle;
      this.formId = this.dataset.formId;
      this.hasOpt1 = this.dataset.hasOpt1 === 'true';
      this.hideOpt1 = this.dataset.hideOpt1 === 'true';
      this.exclusionsEnabled = this.dataset.exclusionsEnabled === 'true';
      this.showWhenDiscounted = this.dataset.showWhenDiscounted === 'true';

      let cfg = {};
      try { cfg = JSON.parse(this.querySelector('[data-mr-config]').textContent); }
      catch (e) { console.warn('[lia-mr] Konfiguration nicht lesbar', e); }
      this.variants = cfg.variants || [];
      this.opt1Values = cfg.opt1Values || [];
      this.excludedOpt1 = list(cfg.excludedOpt1);
      this.excludedOther = list(cfg.excludedOther);
      this.ignoreValues = list(cfg.ignoreValues);
      this.soldOutLabel = cfg.soldOutLabel || 'ausverkauft';
      this.opt1Name = (cfg.options || [])[0] || 'Farbe';
      this.currentVariant = cfg.selected || this.variants[0] || null;

      try {
        this.moneyFmt = new Intl.NumberFormat(this.dataset.locale || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      } catch (e) {
        this.moneyFmt = { format: (n) => n.toFixed(2).replace('.', ',') + ' €' };
      }

      this.boxes = Array.from(this.querySelectorAll('[data-box-index]'));
      this.activeBoxIndex = parseInt(this.dataset.defaultBox, 10) || 1;
      this.unitState = { 1: [], 2: [], 3: [] };

      // Aktuellen Picker-Zustand übernehmen (z. B. ?variant= in der URL)
      const picker = this._picker();
      if (picker && picker.currentVariant) this.currentVariant = picker.currentVariant;

      instances.set(this.sectionId, this);
      this._bindBoxes();
      this._render();
    }

    disconnectedCallback() {
      if (instances.get(this.sectionId) === this) instances.delete(this.sectionId);
    }

    /* ---------- Helfer ---------- */

    _picker() {
      return document.querySelector('variant-options[data-section="' + this.sectionId + '"]');
    }

    _money(cents) {
      return (cents == null || isNaN(cents)) ? '—' : this.moneyFmt.format(cents / 100);
    }

    _activeBox() {
      return this.boxes.find((b) => parseInt(b.dataset.boxIndex, 10) === this.activeBoxIndex);
    }

    // Variante mit gegebenem Wert für Option 1, übrige Optionen wie die aktuelle
    _variantFor(opt1) {
      const cur = this.currentVariant || {};
      return this.variants.find((v) =>
        v.option1 === opt1 &&
        (cur.option2 == null || v.option2 === cur.option2) &&
        (cur.option3 == null || v.option3 === cur.option3)
      );
    }

    _isAvailable(opt1) {
      const v = this._variantFor(opt1);
      return !!(v && v.available);
    }

    // Streichpreis vorhanden UND nicht nur Rechen-Vergleich (Ignore-Liste, Option 2/3)
    _isReallyDiscounted(v) {
      if (!v || v.compare_at_price == null || v.compare_at_price <= v.price) return false;
      if (this.ignoreValues.includes(norm(v.option2)) || this.ignoreValues.includes(norm(v.option3))) return false;
      return true;
    }

    _effectiveDiscount(box) {
      const normal = parseFloat(box.dataset.discount) || 0;
      if (!this._isReallyDiscounted(this.currentVariant)) return normal;
      const alt = parseFloat(box.dataset.discountAlt);
      return isNaN(alt) ? normal : alt;
    }

    // Pro Stück wählen: ab 2 Stück – oder immer, wenn Option 1 im Picker ausgeblendet ist
    _showUnits(qty) {
      return this.hasOpt1 && (qty >= 2 || this.hideOpt1);
    }

    /* ---------- Ausnahmen ---------- */

    _applyExclusion() {
      const v = this.currentVariant || {};
      const opt1Excluded = this.exclusionsEnabled && this.hasOpt1 && this.excludedOpt1.includes(norm(v.option1));
      const otherExcluded = this.exclusionsEnabled && (this.excludedOther.includes(norm(v.option2)) || this.excludedOther.includes(norm(v.option3)));
      this.isExcluded = opt1Excluded || otherExcluded;
      this.style.display = this.isExcluded ? 'none' : '';
      // Bei Ausschluss: Mengenzähler + ggf. Option 1 im Picker wieder einblenden
      document.body.classList.toggle('lia-mr-excluded-' + this.sectionHandle, this.isExcluded);
      document.body.classList.toggle('lia-mr-show-opt1-' + this.sectionHandle, this.isExcluded);
    }

    /* ---------- Kästchen ---------- */

    _bindBoxes() {
      this.boxes.forEach((box) => {
        box.addEventListener('click', (ev) => {
          if (ev.target.closest('.lia-mr__dd')) { return; }
          this._selectBox(parseInt(box.dataset.boxIndex, 10));
        });
      });
    }

    _selectBox(idx) {
      if (this.activeBoxIndex === idx) return;
      this.activeBoxIndex = idx;
      this.boxes.forEach((b) => {
        const on = parseInt(b.dataset.boxIndex, 10) === idx;
        b.classList.toggle('is-active', on);
        const inp = b.querySelector('input[type="radio"]');
        if (inp) inp.checked = on;
      });
      this._renderUnits();
      this._updatePrices();
    }

    /* ---------- Variantenwechsel ---------- */

    _onVariantChange(variant) {
      if (!variant) return; // nicht existierende Kombination – Theme zeigt "nicht verfügbar"
      const prevOpt1 = this.currentVariant && this.currentVariant.option1;
      this.currentVariant = variant;
      // Picker-Auswahl in Slot 1 aller Kästchen spiegeln
      if (this.hasOpt1 && prevOpt1 !== variant.option1) {
        [1, 2, 3].forEach((i) => { this.unitState[i][0] = variant.option1; });
      }
      this._render();
    }

    _setPickerOption1(value) {
      const picker = this._picker();
      if (!picker) return;
      const opt = picker.querySelector('.wt-product__option');
      if (!opt) return;
      const radio = Array.from(opt.querySelectorAll('input[type="radio"]')).find((r) => r.value === value);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* ---------- Rendern ---------- */

    _render() {
      this._applyExclusion();
      this._renderUnits();
      this._updatePrices();
    }

    _updatePrices() {
      const base = (this.currentVariant && this.currentVariant.price) || 0;
      this.classList.toggle('is-variant-discounted', this._isReallyDiscounted(this.currentVariant) && !this.showWhenDiscounted);

      this.boxes.forEach((box) => {
        const qty = parseInt(box.dataset.qty, 10) || 1;
        const disc = this._effectiveDiscount(box);
        // Einzelpreise je Stück: aktives Kästchen mit den gewählten Varianten,
        // sonst Basispreis × Menge.
        let unitPrices = Array(qty).fill(base);
        if (box === this._activeBox() && this._showUnits(qty)) {
          const sel = this._selectedUnits();
          if (sel.length) unitPrices = sel.map((val) => { const v = this._variantFor(val); return v ? v.price : base; });
        }
        // Wie Shopify: Rabattbetrag pro Stück berechnen und auf den Cent ABrunden,
        // dann summieren (nicht die Summe rabattieren). Preise sind in Cent.
        // Geprüft am Warenkorb: 14,99 € −15 % → 2,2485 → 2,24 € Rabatt je Stück.
        const regular = unitPrices.reduce((s, p) => s + p, 0);
        const total = unitPrices.reduce((s, p) => s + p - Math.floor(p * disc / 100 + 1e-9), 0);

        const priceEl = box.querySelector('[data-mr-price]');
        const compareEl = box.querySelector('[data-mr-compare]');
        if (priceEl) priceEl.textContent = this._money(total);
        if (compareEl) compareEl.textContent = disc > 0 ? this._money(regular) : '';

        const savings = box.querySelector('[data-mr-savings]');
        if (savings && !savings.hasAttribute('data-mr-no-discount')) {
          savings.textContent = disc > 0 ? '-' + disc + '%' : '';
          savings.hidden = disc <= 0;
        }
      });
      this._updateImages();
    }

    // Automatische Bilder (Variantenbild je Stück): aktives Kästchen zeigt die
    // pro Stück gewählten Farben, alle anderen die aktuell gewählte Variante.
    _updateImages() {
      if (this.dataset.autoImages !== 'true') return;
      const cur = this.currentVariant || {};
      const imgOf = (v) => {
        const src = v && v.featured_image && v.featured_image.src;
        return src ? src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=160' : null;
      };
      this.boxes.forEach((box) => {
        const stack = box.querySelector('[data-mr-stack]');
        if (!stack) return;
        const qty = parseInt(box.dataset.qty, 10) || 1;
        const values = (box === this._activeBox() && this._showUnits(qty)) ? this._selectedUnits() : [];
        stack.querySelectorAll('img').forEach((img, i) => {
          const v = (this.hasOpt1 && values[i] != null) ? this._variantFor(values[i]) : cur;
          const src = imgOf(v) || imgOf(cur);
          if (!src || img.getAttribute('src') === src) return;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = src;
        });
      });
    }

    _renderUnits() {
      if (!this.hasOpt1) return;
      const cur = this.currentVariant || {};
      const available = this.opt1Values.filter((v) => this._isAvailable(v));
      const curOpt1 = cur.option1;
      const fallback = curOpt1 || available[0] || this.opt1Values[0] || '';
      const opt1Name = this.opt1Name;

      this.boxes.forEach((box) => {
        const idx = parseInt(box.dataset.boxIndex, 10);
        const host = box.querySelector('[data-mr-units]');
        if (!host) return;
        const qty = parseInt(box.dataset.qty, 10) || 1;
        if (idx !== this.activeBoxIndex || !this._showUnits(qty)) { host.innerHTML = ''; return; }

        const prev = this.unitState[idx] || [];
        const next = [];
        for (let i = 0; i < qty; i++) {
          let val = prev[i] || fallback;
          // Slot 1 folgt immer dem Picker; weitere Slots fallen bei ausverkauft auf Slot 1 zurück
          if (i === 0) val = curOpt1 || val;
          else if (!this._isAvailable(val)) val = available.includes(fallback) ? fallback : (available[0] || fallback);
          next.push(val);
        }
        this.unitState[idx] = next;

        host.innerHTML = next.map((val, i) => {
          // Aktuell gewählter, aber ausverkaufter Wert bleibt sichtbar (deaktiviert)
          const values = available.includes(val) ? available : [val].concat(available);
          const opts = values.map((v) => {
            const sold = !available.includes(v);
            return '<li class="lia-mr__dd-opt" role="option" tabindex="-1" data-value="' + esc(v) + '"' +
              ' aria-selected="' + (v === val) + '"' + (sold ? ' aria-disabled="true"' : '') + '>' +
              this._dotHTML(v) + '<span class="lia-mr__dd-text">' + esc(v) +
              (sold ? ' <small>– ' + esc(this.soldOutLabel) + '</small>' : '') + '</span></li>';
          }).join('');
          return '<span class="lia-mr__unit">' +
            '<span class="lia-mr__unit-no">' + (i + 1) + '.</span>' +
            '<span class="lia-mr__dd" data-mr-unit="' + i + '">' +
              '<button type="button" class="lia-mr__dd-btn" aria-haspopup="listbox" aria-expanded="false" aria-label="' + esc(opt1Name) + ' ' + (i + 1) + ': ' + esc(val) + '">' +
                this._dotHTML(val) + '<span class="lia-mr__dd-text">' + esc(val) + '</span>' +
              '</button>' +
              '<ul class="lia-mr__dd-list" role="listbox" hidden>' + opts + '</ul>' +
            '</span>' +
            '</span>';
        }).join('');

        host.querySelectorAll('.lia-mr__dd').forEach((dd) => this._bindDropdown(dd, idx));
      });
    }

    /* ---------- Farb-Dropdown mit Swatches ---------- */

    // Farbpunkte aus dem Swatch-Picker des Themes übernehmen (gleiche Optik);
    // Fallback: Variantenbild als Mini-Thumbnail.
    _swatchFor(value) {
      if (!this._swatchMap) {
        this._swatchMap = {};
        const picker = this._picker();
        const opt = picker && picker.querySelector('.wt-product__option');
        if (opt) {
          opt.querySelectorAll('input[type="radio"]').forEach((input) => {
            const label = opt.querySelector('label[for="' + input.id + '"]');
            if (!label) return;
            const content = label.querySelector('[style*="background"]');
            const img = label.querySelector('img');
            if (content) this._swatchMap[input.value] = { style: content.getAttribute('style') };
            else if (img) this._swatchMap[input.value] = { img: img.currentSrc || img.src };
          });
        }
      }
      const hit = this._swatchMap[value];
      if (hit) return hit;
      const v = this._variantFor(value);
      const src = v && v.featured_image && v.featured_image.src;
      return src ? { img: src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=60' } : null;
    }

    _dotHTML(value) {
      const sw = this._swatchFor(value);
      if (!sw) return '<span class="lia-mr__dot" aria-hidden="true"></span>';
      if (sw.img) return '<span class="lia-mr__dot lia-mr__dot--img" aria-hidden="true"><img src="' + esc(sw.img) + '" alt="" loading="lazy"></span>';
      return '<span class="lia-mr__dot" aria-hidden="true" style="' + esc(sw.style) + '"></span>';
    }

    _bindDropdown(dd, idx) {
      const i = parseInt(dd.dataset.mrUnit, 10);
      const btn = dd.querySelector('.lia-mr__dd-btn');
      const list = dd.querySelector('.lia-mr__dd-list');
      const opts = () => Array.from(list.querySelectorAll('.lia-mr__dd-opt:not([aria-disabled="true"])'));

      const close = (focusBtn) => {
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        dd.classList.remove('is-open');
        if (focusBtn) btn.focus();
      };
      const open = () => {
        this.querySelectorAll('.lia-mr__dd.is-open').forEach((o) => { if (o !== dd) closeDropdown(o); });
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        dd.classList.add('is-open');
        const sel = list.querySelector('[aria-selected="true"]') || opts()[0];
        if (sel) { sel.focus(); sel.scrollIntoView({ block: 'nearest' }); }
      };
      const choose = (value) => {
        close(true);
        this.unitState[idx][i] = value;
        if (i === 0) {
          [1, 2, 3].forEach((o) => { this.unitState[o][0] = value; });
          this._setPickerOption1(value); // löst variantChangeEnd aus -> Preise/Galerie/Neu-Rendern
        } else {
          this._renderUnits();
          this._updatePrices();
        }
      };

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (list.hidden) open(); else close(false);
      });
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
      });
      list.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const li = e.target.closest('.lia-mr__dd-opt');
        if (!li || li.getAttribute('aria-disabled') === 'true') return;
        choose(li.dataset.value);
      });
      list.addEventListener('keydown', (e) => {
        const all = opts();
        const pos = all.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (all[pos + 1] || all[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (all[pos - 1] || all[all.length - 1]).focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (all[pos]) choose(all[pos].dataset.value); }
        else if (e.key === 'Escape' || e.key === 'Tab') { close(e.key === 'Escape'); }
      });
    }

    _selectedUnits() {
      return (this.unitState[this.activeBoxIndex] || []).slice();
    }

    /* ---------- Warenkorb ---------- */

    _buildItems() {
      const box = this._activeBox();
      const cur = this.currentVariant;
      if (!box || !cur) return [];
      const qty = parseInt(box.dataset.qty, 10) || 1;
      if (!this._showUnits(qty)) return [{ id: cur.id, quantity: qty }];

      const counts = new Map();
      this._selectedUnits().forEach((val) => {
        const v = this._variantFor(val);
        if (v) counts.set(v.id, (counts.get(v.id) || 0) + 1);
      });
      return Array.from(counts, ([id, quantity]) => ({ id, quantity }));
    }

    _handleAddToCart(form) {
      const productForm = form.closest('product-form');
      const btn = form.querySelector('[type="submit"]');
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;

      const items = this._buildItems();
      if (!items.length) { console.warn('[lia-mr] Keine gültigen Artikel.'); return; }

      const cart = document.querySelector('cart-drawer');
      if (productForm && typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();
      if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }

      const body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.section || s.id);
        body.sections_url = window.location.pathname;
      }

      const url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, { source: 'product-mengenrabatt', productVariantId: items[0].id, errors: res.errors || res.description, message: res.message });
            }
            throw new Error(res.description || res.message || 'Fehler beim Hinzufügen');
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-mengenrabatt', productVariantId: items[0].id, cartData: res });
          }
          if (cart && res.sections && typeof cart.renderContents === 'function') {
            cart.classList.remove('is-empty');
            cart.renderContents(res, !document.body.classList.contains('page-overlay-cart-on'));
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch((err) => {
          console.error('[lia-mr]', err);
          if (productForm && typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage(err.message);
        })
        .finally(() => {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
        });
    }
  }

  window.customElements.define('product-mengenrabatt', ProductMengenrabatt);
})();
